import React, { useEffect, useState } from 'react'
import { FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { updateInitialUsabilityFilled, updateUsability, updateUsabilityLimit, updateUsabilitySkip, } from '../../../../../stateManagement/actions/manageCouponActions';
import { isOnlyDateUpdate, isOnlyDigit } from '../../../services/services';
import { useSelector } from 'react-redux';
import CouponBox from '../../CouponBox';
import SkipThisStep from './SkipThisStep';
import { labelMappings, MetaData } from '../../../utils/utils';
import { getUsabilityPeriodList } from "../../../services/services"

function Usability() {
    const { iniUsabilityLimit, iniUsability,initialUsabilityFilled,usabilityLimit, usability, skipCouponLife, skipUsability } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence);
    // const [usabilityPeriod, setusabilityPeriod] = React.useState(orderResetusabilityPeriod);
    const couponLife = useSelector((state: any) => Number(state?.manageCoupons?.data?.recurrence?.couponLife) || 0);
    const [usabilityPeriod, setusabilityPeriod] = useState<string>(usability);
    const [skipStep, setSkipStepPressed] = useState(useSelector((state: any) => Boolean(state?.manageCoupons?.data?.recurrence?.skipUsability) || false));
    const { couponEditType } = useSelector((state: any) => state.manageCoupons?.data);
    const [editIniUsablity, setEditIniUsablity] = useState(useSelector((state: any) => Boolean(state?.manageCoupons?.data?.recurrence?.usability === "" || state?.manageCoupons?.data?.recurrence?.usability == null) || false))
    const [usabilityPeriodLimit, setusabilityPeriodLimit] = useState(usabilityLimit);
    const [errorText, setErrorText] = useState("");

    const handleUsabilityPeriodLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = (event.target as HTMLInputElement).value.trim().replace(/^0+/, '')
        setusabilityPeriod(value);

        updateUsability(value);
        if (couponLife < Number(value)) {
            setErrorText(labelMappings["usability-limit-error"]);
        }
        else {
            setErrorText("");
        }
    };
    const handleLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = (event.target as HTMLInputElement).value.trim().replace(/^0+/, '');
        if (isOnlyDigit(inputValue)) {
            setusabilityPeriodLimit((event.target as HTMLInputElement).value);
            updateUsabilityLimit((event.target as HTMLInputElement).value);
            if ((couponLife !== 0 || skipCouponLife) && couponLife < Number(inputValue)) {
                setErrorText(labelMappings["usability-limit-error"]);
            }
            else {
                setErrorText("");
            }
        }
    };
    useEffect(() => {
        if ((couponLife !== 0 || skipCouponLife) && couponLife < Number(usabilityLimit)) {
            setErrorText(labelMappings["usability-limit-error"]);
        }
        else {
            setErrorText("");
        }
    }, [usabilityLimit, couponLife]);

    const handleSkipThisStep = () => {



        if(couponEditType === "edit" && !initialUsabilityFilled){
            if (skipStep) {
                setSkipStepPressed(false);
                updateUsabilitySkip(false);
            }
            else {
                setSkipStepPressed(true);
                updateUsabilityLimit("");
                updateUsabilitySkip(true);
                updateUsability("");
                setusabilityPeriodLimit("");
                setusabilityPeriod("");
                setErrorText("");
            }
        }
        else if (couponEditType === "edit") {
            if (skipStep) {
                setSkipStepPressed(false);
                updateUsabilitySkip(false);
                setusabilityPeriodLimit(iniUsabilityLimit);
                updateUsabilityLimit(iniUsabilityLimit);
                updateUsability(iniUsability);
                setusabilityPeriod(iniUsability);
            }
            else {
                setSkipStepPressed(true);
                updateUsabilitySkip(true);
                updateUsabilityLimit(null);
                updateUsability(null);
                setusabilityPeriodLimit("");
                setusabilityPeriod("");
                setErrorText("");
            }
        } else {
            if (skipStep) {
                setSkipStepPressed(false);
                updateUsabilitySkip(false);
            }
            else {
                setSkipStepPressed(true);
                updateUsabilityLimit("");
                updateUsabilitySkip(true);
                updateUsability("");
                setusabilityPeriodLimit("");
                setusabilityPeriod("");
                setErrorText("");
            }
        }
    };

    const usabilityArray = getUsabilityPeriodList();
    return (
        <div className={`${isOnlyDateUpdate() && couponEditType === "edit" ? 'recurrence-blurred-uneditable' : ''}`}> 
        <CouponBox disabled={skipStep} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'usability'} style={{ color: 'inherit' }} />{
            <SkipThisStep onClick={handleSkipThisStep} />
        }
        </>}>
            {/* <CouponBox disabled={skipStep} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'usability'} style={{ color: 'inherit' }} /><SkipThisStep onClick={handleSkipThisStep} /></>}> */}
            <div className="order-reset-freq" style={{ margin: skipStep ? "1px" : "0px" }}>
                <div className='applicable-slab-single-field' style={{ display: 'flex', alignItems: 'center', marginBottom: "20px", marginTop: "10px" }}>
                    <div className="applicable-slab-single-field-left" style={{ width: '30%', margin: "10px" }}>
                        <p style={{ color: '#989898', fontSize: '14px', fontWeight: "bold" }}>{labelMappings["usability-limit-label"]}</p>
                    </div>
                    <TextField
                        id="outlined-basic"
                        onChange={handleLimitChange}
                        value={usabilityPeriodLimit}
                        placeholder={labelMappings["recurrence-usability-limit"]}
                        variant="outlined"
                        size="small"
                        error={errorText !== ""}
                        helperText={errorText}
                    />
                </div>
                <FormControl>
                    <RadioGroup
                        aria-label="usabilityPeriod"
                        name="usabilityPeriod"
                        value={usabilityPeriod}
                        onChange={handleUsabilityPeriodLimitChange}
                    >
                        {
                            usabilityArray.map((usabilityValue, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={usabilityValue}
                                    className="radio-order-reset-freq"
                                    control={<Radio disabled={couponEditType === "edit" && initialUsabilityFilled && iniUsability!=="" } />}
                                    label={usabilityValue}
                                />
                            ))}
                    </RadioGroup>
                </FormControl>
            </div>
        </CouponBox>
        </div>
    )
}

export default Usability;